import { Button, FormControl, TextField } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import { useState } from "react";
import styles from "../../styles/AddNewParticipant.module.scss";
import { useAlert } from "react-alert";
import { Axios } from "../../App";

type TProps = {
  fontColor?: string;
};

const PageAddNewParticipant = ({ fontColor }: TProps) => {
  const navigate = useNavigate();
  const alert = useAlert();
  const [name, setName] = useState<string>("");
  const [numberOfAdditionalGuests, setNumberOfAdditionalGuests] = useState<number>(0);
  const [note, setNote] = useState<string>("");
  const [field1, setField1] = useState<string>("");
  const [field2, setField2] = useState<string>("");
  const [field3, setField3] = useState<string>("");
  const { id } = useParams();

  const saveNewParticipant = async () => {
    await Axios.post("participants/saveSingleParticipantByEventID.php", {
      id: id,
      name: name,
      numberOfAdditionalGuests: numberOfAdditionalGuests,
      note: note,
      field1: field1,
      field2: field2,
      field3: field3
    })
      .then(({ data }) => {
        if (!data?.success) throw new Error(data?.message);
        alert.info("Elmentve!")
        setTimeout(() => {
          navigate(`/${id}/event-manager`);
        }, 1500);
      })
      .catch((e) => {
        console.error(e);
      });
  };

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    saveNewParticipant();
    setName("");
    setNote("");
    setNumberOfAdditionalGuests(0);
    setField1("");
    setField2("");
    setField3("");
  };

  return (
    <article className={styles.wrapper}>
      <form className={styles.form} onSubmit={(e) => handleSubmit(e)}>
        <FormControl fullWidth>
          <TextField
            id="name-input"
            name="name"
            label="Név"
            type="text"
            value={name}
            required
            onChange={(e) => setName(e.target.value)}
            sx={{
              color: fontColor,
              input: {
                color: fontColor,
              },
              label: {
                color: fontColor,
              },
              fieldset: {
                borderColor: fontColor,
              },
            }}
          />
        </FormControl>
        <FormControl fullWidth>
          <TextField
            id="numberOfAdditionalGuest-input"
            name="numberOfAdditionalGuest"
            label="Hozott vendégek száma"
            type="number"
            value={numberOfAdditionalGuests}
            required
            onChange={(e) => setNumberOfAdditionalGuests(parseInt(e.target.value))}
            sx={{
              color: fontColor,
              input: {
                color: fontColor,
              },
              label: {
                color: fontColor,
              },
              fieldset: {
                borderColor: fontColor,
              },
            }}
          />
        </FormControl>
        <FormControl fullWidth>
          <TextField
            id="note"
            name="note"
            label="Megjegyzés"
            type="text"
            value={note}
            onChange={(e) => setNote(e.target.value)}
            sx={{
              color: fontColor,
              input: {
                color: fontColor,
              },
              label: {
                color: fontColor,
              },
              fieldset: {
                borderColor: fontColor,
              },
            }}
          />
        </FormControl>
        <FormControl fullWidth>
          <TextField
            id="field1"
            name="field1"
            label="Mező 1"
            type="text"
            value={field1}
            onChange={(e) => setField1(e.target.value)}
            sx={{
              color: fontColor,
              input: {
                color: fontColor,
              },
              label: {
                color: fontColor,
              },
              fieldset: {
                borderColor: fontColor,
              },
            }}
          />
        </FormControl>
        <FormControl fullWidth>
          <TextField
            id="field2"
            name="field2"
            label="Mező 2"
            type="text"
            value={field2}
            onChange={(e) => setField2(e.target.value)}
            sx={{
              color: fontColor,
              input: {
                color: fontColor,
              },
              label: {
                color: fontColor,
              },
              fieldset: {
                borderColor: fontColor,
              },
            }}
          />
        </FormControl>
        <FormControl fullWidth>
          <TextField
            id="field3"
            name="field3"
            label="Mező 3"
            type="text"
            value={field3}
            onChange={(e) => setField3(e.target.value)}
            sx={{
              color: fontColor,
              input: {
                color: fontColor,
              },
              label: {
                color: fontColor,
              },
              fieldset: {
                borderColor: fontColor,
              },
            }}
          />
        </FormControl>
        <Button
          variant="contained"
          color="primary"
          type="submit"
          disabled={!name}
        >
          Mentés
        </Button>
      </form>
    </article>
  );
};

export default PageAddNewParticipant;
